import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Tooltip as AntTooltip } from "antd";
import Color from "../../enums/color";
import { LAYOUT_SELECTOR } from "../../constants/shared";
const Tooltip = ({ title, destroyTooltipOnHide = true, placement = "bottom", color = Color.MicrosoftBlue, children, className, getPopupContainer = () => document.body }) => {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => {
        var _a;
        const listener = () => {
            setIsVisible(false);
        };
        (_a = document.querySelector(LAYOUT_SELECTOR)) === null || _a === void 0 ? void 0 : _a.addEventListener("scroll", listener, { passive: true });
        return () => {
            var _a;
            (_a = document.querySelector(LAYOUT_SELECTOR)) === null || _a === void 0 ? void 0 : _a.removeEventListener("scroll", listener);
        };
    }, []);
    return (<AntTooltip title={title} destroyTooltipOnHide={destroyTooltipOnHide} placement={placement} color={color} overlayClassName={className} getPopupContainer={getPopupContainer} visible={isVisible} arrowPointAtCenter={true}>
      <div onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
        {children}
      </div>
    </AntTooltip>);
};
const StyledTooltip = styled(Tooltip) `
  min-width: ${props => props.isMinWidthUnset ? "unset" : "fit-content"};
  font-size: 12px;
`;
export default StyledTooltip;
